export default __webpack_public_path__ + "eb6566941800fdf3ddc1e7f342a364e6.png";